<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="评价期" prop="monthList">
                <el-select v-model="queryCondition.monthList" clearable multiple placeholder="请选择(支持多选)" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in monthOptions" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="DC名称" prop="dcName">
                <el-input v-model="queryCondition.dcName" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="status">
                <ic-select clearable table="TT_QSPI_DQMP" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="只显示有附件" prop="isFile">
                <el-checkbox v-model="queryCondition.isFile"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onBatch" v-acl="QSPI_DQMP_SAVE">批量维护</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="QSPI_DQMP_EXPORT">导出</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="550" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="评价期" field="month" resizable min-width="100"></ux-table-column>
        <ux-table-column align="center" title="DC编码" field="dcCode" resizable min-width="120">
          <template v-slot="scope">
            <el-button type="text" @click="onDetail(scope.row,scope.$index)">{{scope.row.dcCode}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="DC名称" field="dcName" resizable min-width="150"></ux-table-column>
        <ux-table-column align="center" title="Outbound" field="outbound" resizable min-width="180"></ux-table-column>
        <ux-table-column align="center" title="分数" field="score" resizable min-width="90"></ux-table-column>
        <ux-table-column align="center" title="等级" field="grade" resizable min-width="90"></ux-table-column>
        <ux-table-column align="center" title="状态" field="statusI18n" resizable min-width="90"></ux-table-column>
        <ux-table-column align="center" title="附件" resizable min-width="120">
          <template v-slot="scope">
            <el-popover placement="right" width="300" trigger="click">
              <el-table :data="JSON.parse(scope.row.files)">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column show-overflow-tooltip property="documentName" label="文件名称">
                  <template slot-scope="scope">
                    <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="text" slot="reference">查看附件</el-button>
            </el-popover>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="更新人" field="updateName" resizable min-width="150"></ux-table-column>
        <ux-table-column align="center" title="更新日期" field="updateDate" resizable min-width="180"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="showDetailDialog" title="维护DQMP评分" append-to-body width="80%" :close-on-click-modal="false" @close="closeDialog">
      <dqmpDialog v-if="showDetailDialog"></dqmpDialog>
    </el-dialog> -->
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index';
import DQMPApi from "@/api/DQMP/index";
import { fileService } from "@/api/common/file-utils";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
export default {
  name: 'dqmp',
  mixins: [paginationMixin],
  components: {
    IcSelect,
  },
  data() {
    return {
      queryCondition: {
        monthList: [],
        dcName: "",
        isFile: "",
        status: "",
        pageNum: 1,
        pageSize: 15,
      },
      monthOptions: [],
      detailTable: [],
      tableData: [],
      ttQspiDqmpIdList: [],
      multipleSelection: [],
      totalCount: 0,
      pages: 1,
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to 1111', to);
    if (to.query.month) {
      to.meta.reqData.monthList=[]
      to.meta.reqData.monthList.push(to.query.month);
    }
    DQMPApi.findDqmpListPage(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.data.records;
        vm.totalCount = res.data.total;
      })
    })
  },
  
  mounted() {
    this.$nextTick(() => {
      // this.queryData();
      this.getMonth()
    })
  },
  methods: {
    queryData() {
      DQMPApi.findDqmpListPage(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
        this.$refs.plxTable.reloadData(res.data.records)
      });
    },
    // 选中的行
    selectionChange(row) {
      this.ttQspiDqmpIdList = []
      this.multipleSelection = row
      row.forEach(ele => {
        this.ttQspiDqmpIdList.push(ele.ttQspiDqmpId)
      });
    },
    onBatch() {
      sessionStorage.setItem('ttQspiDqmpIdList', JSON.stringify(this.ttQspiDqmpIdList))
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请勾选数据")
        return false
      }
      for (let i = 0; i < this.multipleSelection.length; i++) {
        const ele = this.multipleSelection[i];
        if (this.multipleSelection[i].status !== this.multipleSelection[0].status && i !== 0) {
          this.$message.warning("请选择状态一致的数据进行维护")
          return false
        }
      }
      this.$router.push({
        path: '/qspiDQMP/detail',
        query: {
          status: this.multipleSelection[0].status
        }
      })
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        monthList: [],
        dcName: "",
        isFile: "",
        status: "",
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
    getMonth() {
      DQMPApi.getMonth().then(res => {
        this.monthOptions = res
      })
    },
    onDetail(row, index) {
      this.ttQspiDqmpIdList.push(row.ttQspiDqmpId)
      sessionStorage.setItem('ttQspiDqmpIdList', JSON.stringify(this.ttQspiDqmpIdList))
      this.$router.push({
        path: '/qspiDQMP/detail',
        query: {
          status: row.status
        }
      })
    },
    onExport() {
      this.$set(this.queryCondition, 'ttQspiDqmpIdList', this.ttQspiDqmpIdList)
      DQMPApi.dqmpDownload(this.queryCondition).then(res => {
        fileService.respToFile(res, 'QSPI_DQMP_Report.xlsx');
      });
    },
    onDownload(item, index) {
      fileService.downloadFile(item).then((res) => { })
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
